import React from 'react';
import Logo from '../../elements/logo/Logo';
import Nav from '../../common/header/Nav';
// import StickyHeader from './StickyHeader';
import SwitcherHeader from '../../elements/switcher/SwitcherHeader';


const HeaderOne = () => {

    // const sticky = StickyHeader(100);


    return (
        <>
            <header className="header axil-header header-style-1">
                {/* <div className={`axil-mainmenu ${sticky ? "axil-sticky" : ""}`}> */}
                <div className={`axil-mainmenu axil-sticky`}>
                    <div className="container">
                        <div className="header-navbar">
                            <div className="header-logo">
                                <Logo limage="/images/logo_sousa.png"
                                    dimage="/images/logo_sousa.png"
                                    simage="/images/logo_sousa.png"
                                />
                            </div>
                            <div className="header-main-nav">
                                <Nav />
                            </div>
                            <div className="header-action">
                                <ul className="list-unstyled">
                                    <li className="my_switcher d-block d-lg-none">
                                        <SwitcherHeader />
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
        </>
    )
}

export default HeaderOne;